let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7C4Cq")).then(() => parcelRequire('2Psbj'));